import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, Input, input, output, OnInit } from '@angular/core';
import { Types } from 'shared-lib';
import { EComponentSize, EIcon, ELabelType } from '../../types';
import { ButtonComponent } from '../button/button.component';
import { LabelComponent } from '../label/label.component';
import { IImageStatus } from '../../types/imageStatus';
import { helper } from '../../../public-api';

@Component({
  selector: 'ui-image-validator',
  standalone: true,
  imports: [CommonModule, ButtonComponent, LabelComponent],
  templateUrl: './image-validator.component.html',
  styleUrls: ['./image-validator.component.scss']
})
export class ImageValidatorComponent implements OnInit {
  imageUrls = input.required<string[]>();

  imageStatus: IImageStatus[] = [];
  currentIndex: number = 0;
  ELabelType = ELabelType;
  EComponentSize = EComponentSize;
  EIcon = EIcon;
  EAlert = Types.EAlert;

  validationResult = output<IImageStatus[]>();
  darkMode = false;

  ngOnInit(): void {
    this.darkMode = helper.Functions.isDarkMode();
  }

  ngOnChanges() {
    this.imageStatus = this.imageUrls().map(url => ({ url, isApproved: null }));
  }

  approveImage() {
    this.imageStatus[this.currentIndex].isApproved = true;
    this.nextImage();
  }

  rejectImage() {
    this.imageStatus[this.currentIndex].isApproved = false;
    this.nextImage();
  }

  nextImage() {
    if (this.currentIndex < this.imageUrls().length - 1) {
      this.currentIndex++;
    } else {
      this.validationResult.emit(this.imageStatus);
      this.currentIndex++;
    }
  }
}
